import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

export const getIssueNumberFromIssueKey = (issueKey: IssueKey = '') => {
	const parsedNumber = parseInt(issueKey.split('-')[1], 10);

	return Number.isNaN(parsedNumber) ? undefined : parsedNumber;
};
